module.exports = __webpack_public_path__ + "static/media/control-verde.dbe2ad49.svg";